<template>
  <div class="login">
    
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
    }
  },
  mounted(){
    
  },
  methods:{
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 

</style>



// WEBPACK FOOTER //
// src/views/statistics/Statistics.vue